import { subDays } from "date-fns";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient, useTypedQuery } from "hooks";
import { QUESTION_RESULT_STATUSES } from "models";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";
import { LEADS_NOT_SNOOZED_STORAGE_KEYS } from "modules/LeadsDashboard/storageKeys";
import { PAGE_SIZE, getPreference, useUpdateLocationPreference } from "utils/common";
import { toDate } from "utils/dateHelperFunctions";

import type { DealerLocation } from "models";
import type { PossibleQuestionStatusOptions } from "modules/LeadsDashboard/hooks";
import type { LeadsNotSnoozedFilters } from "modules/LeadsDashboard/queryKeys";

export const defaultQuestionResultStatuses = [
  QUESTION_RESULT_STATUSES.OKWithRemarks,
  QUESTION_RESULT_STATUSES.Advice,
  QUESTION_RESULT_STATUSES.Necessary
] as PossibleQuestionStatusOptions[];

export const getDefaultNotSnoozedFilters = (selectedLocation?: DealerLocation | null): LeadsNotSnoozedFilters => ({
  page: 1,
  dealer_ids: getPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.DealerPreference, []),
  search_term: "",
  is_lease_company: null,
  date_from: subDays(new Date(), 30),
  date_to: toDate(new Date()),
  location_ids: getPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.LocationPreference, selectedLocation?.id ? [selectedLocation.id] : []),
  customer_approved: getPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.CustomerApprovedPreference, false),
  interventions: getPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.InterventionsPreference, false),
  statuses: getPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.QuestionStatusPreference, null),
  questions: getPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.InterventionQuestionResultPreference, null),
  tags: getPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.TagsPreference, null),
  page_size: getPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize25)
});

export const useLeadsNotSnoozedFilters = () => {
  const { selectedLocation } = useSelectedLocation();
  useUpdateLocationPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.LocationPreference, selectedLocation);

  return useTypedQuery({ queryKey: LeadsQueryKeys.notSnoozedFilters, initialData: getDefaultNotSnoozedFilters(selectedLocation) }).data;
};

export const setLeadsNotSnoozedFilters = (newFilters: LeadsNotSnoozedFilters) => {
  const filters = typedQueryClient.getQueryData(LeadsQueryKeys.notSnoozedFilters);
  if (!filters) return;
  typedQueryClient.setQueryData(LeadsQueryKeys.notSnoozedFilters, { ...filters, ...newFilters });
};
